module.exports = __webpack_public_path__ + "media/images/gender-99b427aa058ff8e2178a1520d36c1308.svg";